import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentsUnconfirmParams = {
  ids: string[];
};

export const paymentsUnconfirmAtom = createMutationAtomFactory(
  'finance.paymentsUnconfirm',
  (params: PaymentsUnconfirmParams) => ({
    financePaymentsUnconfirm: {
      __args: {
        input: {
          ids: params.ids,
        },
      },
      results: {
        paymentId: true,
        success: true,
        error: true,
      },
      successCount: true,
      failedCount: true,
    },
  }),
);
